import { decodeFCompositionId, FCompositionTypesEnum } from '@spazious/dollhouse-shallow-graph';

import { FEnsemble } from '../fensembles/types.js';
import { FCompositionNode, FNode, FNodeTypesEnum } from '../types/index.js';

export const isFEnsembleNode = (node: FNode): node is FCompositionNode<FEnsemble> => {
  return (
    node.type === FNodeTypesEnum.FComposition &&
    decodeFCompositionId(node.id).type === FCompositionTypesEnum.FEnsemble
  );
};
